module.exports = __webpack_public_path__ + "media/images/icon-marker-f682ff72fc31aa09a65121f7cdc94037.svg";